import { render, staticRenderFns } from "./PartSelector.vue?vue&type=template&id=4c67b6b0&scoped=true&"
import script from "./PartSelector.vue?vue&type=script&lang=js&"
export * from "./PartSelector.vue?vue&type=script&lang=js&"
import style0 from "./PartSelector.vue?vue&type=style&index=0&id=4c67b6b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c67b6b0",
  null
  
)

export default component.exports